"use client";

import { c as _c } from "react/compiler-runtime";
import * as Sentry from "@sentry/nextjs";
import "../index.css";
import { Home01Icon, Refresh01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import Link from "next/link";
import { useEffect } from "react";
import StatusPage from "@/components/routes/status-page";
import { Button } from "@/components/ui/button";
import { exo, jakarta } from "@/lib/fonts";
import { cn } from "@/lib/utils";
export default function GlobalError(t0) {
  const $ = _c(13);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      Sentry.captureException(error);
      console.error(error);
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("font-sans", jakarta.variable, exo.variable);
    t4 = cn(jakarta.variable, "bg-background text-foreground antialiased");
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== reset) {
    t5 = () => reset();
    $[5] = reset;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HugeiconsIcon icon={Refresh01Icon} className="mr-2 h-5 w-5" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <Button variant="default" size="lg" onClick={t5} className="w-full sm:w-auto">{t6}Try again</Button>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Button variant="outline" size="lg" asChild={true} className="w-full sm:w-auto"><Link href="/"><HugeiconsIcon icon={Home01Icon} className="mr-2 h-5 w-5" />Back to home</Link></Button>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7) {
    t9 = <html lang="en" suppressHydrationWarning={true} className={t3}><body className={t4}><StatusPage code="500" title="A critical error occurred" description="Something went badly wrong before the app could fully recover. Please try again, or return home and start from a safe route." viewport="screen" actions={<>{t7}{t8}</>} /></body></html>;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
}